import styled, { css } from 'styled-components';

import arrowDown from '~/assets/icons/arrow_down.svg';
import cross from '~/assets/icons/cross.svg';

import { Text } from '../Text';

const StyledContainer = styled.div`
	position: relative;
`;

const StyledArrowDown = styled.img.attrs({
	src: arrowDown,
	width: 10,
	height: 10,
})<{ $active?: boolean }>`
	rotate: ${(props) => props.$active && '180deg'};
	opacity: 0.5;
	transform-origin: center;
	transition:
		opacity 0.3s ease,
		filter 0.3s ease;
	user-select: none;
	pointer-events: none;
`;

const StyledArrowDownContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	min-width: 20px;
	min-height: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	transition: background-color 0.3s ease;

	.img-icon {
		background-color: #ffffff;
		transition:
			background-color 0.3s ease,
			rotate 0.3s ease;
	}
`;

const StyledTopContainer = styled.div<{
	$focus?: boolean;
}>`
	position: relative;
	z-index: ${(props) => (props.$focus ? 4 : 2)};
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 50px;
	padding: 0 15px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	${Text} {
		color: #ffffff;
		font-size: 14px;
		font-weight: 400;
	}

	&:hover {
		background-color: #ffffff;

		${Text} {
			color: #000000;
		}

		${StyledArrowDownContainer} {
			background-color: #000000;

			.img-icon {
				background-color: #ffffff;
			}
		}
	}

	${(props) =>
		props.$focus &&
		css`
			background-color: #1782ff;

			${StyledArrowDownContainer} {
				background-color: #ffffff;

				.img-icon {
					background-color: #000000;
					rotate: 180deg;
				}
			}
		`}
`;

const StyledCross = styled.img.attrs({
	src: cross,
	width: 14,
	height: 14,
})`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	cursor: pointer;
	user-select: none;
`;

const StyledDropdownContainer = styled.div<{
	$width?: string;
	$height?: string;
}>`
	position: absolute;
	top: calc(100% + 10px);
	width: ${(props) => props.$width || '100%'};
	height: ${(props) => props.$height || 'auto'};
	z-index: 4;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.results-enter {
		opacity: 0;
	}

	&.results-enter-active,
	&.results-enter-done,
	&.results-exit {
		opacity: 1;
	}

	&.results-exit-active {
		opacity: 0;
	}
`;

export {
	StyledArrowDown,
	StyledArrowDownContainer,
	StyledContainer,
	StyledCross,
	StyledDropdownContainer,
	StyledTopContainer,
};
